import type { PatientSearchRequest } from "@elation/api-client/src/stitch-api/models/patientSearchRequest";
import { IS_IN_IFRAME } from "@src/env";
import { create } from "zustand";

export type Ehr = "elation" | "athenahealth" | "eclinicalworks";

export type PatientFromIframe = {
  id: number;
} & PatientSearchRequest;

export interface IframeStore {
  ehr: Ehr | null;
  setEhr: (ehr: Ehr) => void;
  patient: PatientFromIframe | null;
  setPatient: (patient: PatientFromIframe) => void;
  user_email: string | null;
  setUserEmail: (user_email: string) => void;
}

export const iframeStore = create<IframeStore>()((set) => ({
  ehr: null,
  setEhr: (ehr: Ehr) => set({ ehr }),
  patient: null,
  setPatient: (patient: PatientFromIframe) => set({ patient }),
  user_email: null,
  setUserEmail: (user_email: string) => set({ user_email }),
}));

export const useIframeStore = iframeStore;

export function usePatientFromIframe() {
  const { patient } = useIframeStore();

  if (!IS_IN_IFRAME) return null;

  return patient;
}

export function useEhrFromIframe() {
  const { ehr } = useIframeStore();

  if (!IS_IN_IFRAME) return null;

  return ehr;
}

export function useIsInElationEHR() {
  const { ehr } = useIframeStore();

  return ehr === "elation" && IS_IN_IFRAME;
}
